import { HEADER } from '@/components/App/AppHeader/enum'

export const state = () => ({
  uId: Date.now(),
  zIndexCounter: 9999,
  isDropdownOpen: {
    messages: false,
    balance: false,
    sidebar: false,
  },
  isHideBackBtn: 0,
  isServerToken: null,
  theme: 'theme-light',
  appConfig: {},
  header: HEADER.FULL,
})
export const mutations = {
  set_header(state, type) {
    if (Object.values(HEADER).includes(type)) state.header = type
  },
  set_theme(state, theme) {
    state.theme = theme
  },
  set_appConfig(state, config) {
    state.appConfig = config
  },
  setUid(state, newUId) {
    state.uId = newUId
  },
  setZIndexCounter(state, newZIndexCounter) {
    state.zIndexCounter = newZIndexCounter
  },
  toggle_isDropdownOpen(state, { type, noClose }) {
    if (!noClose) {
      const wasOpen = state.isDropdownOpen[type]

      Object.keys(state.isDropdownOpen).forEach((key) => {
        state.isDropdownOpen[key] = false
      })

      if (wasOpen) return
    }
    state.isDropdownOpen[type] = !state.isDropdownOpen[type] // Инвертируем состояние
  },
  close_isDropdownClose(state, type) {
    if (type) {
      state.isDropdownOpen[type] = false
    }
    else {
      Object.keys(state.isDropdownOpen).forEach((key) => {
        state.isDropdownOpen[key] = false
      })
    }
  },
  setIsHideBackBtn(state, value) {
    state.isHideBackBtn = value
  },
  setServerToken(state, payload) {
    state.isServerToken = payload
  },
}
export const actions = {
  async actFetch_appConfig({ commit }) {
    try {
      commit('set_appConfig', await this.$api.base.getBaseConfig())
    }
    catch (error) { }
  },
  getUid({ commit, state }) {
    const newUId = state.uId + 1
    commit('setUid', newUId)
    return newUId
  },
  getZIndexCounter({ commit, state }) {
    const newZIndexCounter = state.zIndexCounter + 1
    commit('setZIndexCounter', newZIndexCounter)
    return newZIndexCounter
  },
  toggleDropdown: ({ commit }, payload) => {
    commit('toggle_isDropdownOpen', { type: payload })
  },
  closeDropdown: ({ commit }, type) => {
    commit('close_isDropdownClose')
  },
  setIsHideBackBtn({ commit }, value) {
    commit('setIsHideBackBtn', value)
  },
  act_setTheme({ commit }, { theme }) {
    commit('set_theme', theme)
  },
  act_setHeader({ commit }, { type }) {
    commit('set_header', type)
  },
}
export const getters = {
  zIndexCounter: (state) => state.zIndexCounter,
  isDropdownOpen: (state) => state.isDropdownOpen,
  isServerToken: (state) => state.isServerToken,

  get_theme: (state) => ({
    themeClass: state.theme,
    isDark: state.theme === 'theme-dark',
    isLight: state.theme === 'theme-light',
    theme: state.theme.replace('theme-', ''),

  }),
  get_header: ({ header }) => header,
}
